import type { Query } from './search-params'

// Replaces inline `(a, b) => a === b` calls for bundle size reduction.
export function isEqual(a: unknown, b: unknown): boolean {
  return a === b
}

export function compareArrays<T>(
  a: T[],
  b: T[],
  eq: (a: T, b: T) => boolean
): boolean {
  return (
    a === b ||
    (a.length === b.length && a.every((value, index) => eq(value, b[index]!)))
  )
}

export function compareQuery<T extends Query>(
  a: T | null,
  b: T | null
): boolean {
  if (a === b) {
    return true // Referentially stable
  }
  if (a === null || b === null) {
    return false
  }
  // we expect either strings or arrays, not a mix of both
  if (typeof a === 'string' || typeof b === 'string') {
    return false
  }

  if (a.length !== b.length) {
    return false
  }

  return a.every((value, index) => value === b[index]!)
}
